import { Chip } from "@heroui/react";
import { ChipRemoveButton } from "./ChipRemoveButton";

interface RecipeCategoryChipProps {
    name: string;
    onRemove?: () => void;
}

export const RecipeCategoryChip = ({ name, onRemove }: RecipeCategoryChipProps) => {
    const isRemovable = !!onRemove;
    return (
        <Chip
            size={isRemovable ? "md" : "lg"}
            variant={isRemovable ? "soft" : undefined}
            className={`chip--slate${isRemovable ? " active-filter-chip" : ""}`}
        >
            <Chip.Label>{name}</Chip.Label>
            {onRemove && <ChipRemoveButton label={name} onPress={onRemove} />}
        </Chip>
    );
};
